/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {

	export class DialogOutcome {

		constructor(
			public label: string,
			public isPrimary: boolean = false,
            public isCancel: boolean = false) {
		}

		public static ok = new DialogOutcome('OK', true);
		public static save = new DialogOutcome('Save', true);
		public static confirm = new DialogOutcome('Confirm', true);
		public static confirmAndSave = new DialogOutcome('Confirm and Save', true);
		public static yes = new DialogOutcome('Yes', true);
		public static cancel = new DialogOutcome('Cancel', false, true);
		public static no = new DialogOutcome('No');
	}

}